import CallHistoryInfiniteListComponent from './CallHistoryInfiniteList.component';

export default CallHistoryInfiniteListComponent;
